import * as types from "./types";
import handleResponse from "../../shared/handleResponse";

export type SubCategory = {
  title: string;
  uuid: string;
  default_image_filename: string;
  default_offer_text: string;
  default_layout: number;
  social_feeds: boolean;
};
export type Business = {
  name: string;
  uuid: string;
  formatted_address: string;
};
type BusinessProps = { businesses: Array<Business> };
type SubCategoryProps = { subCategories: Array<SubCategory> };

const setLoading = (value: boolean): object => ({
  type: types.SET_LOADING,
  payload: value,
});

const setBusinesses = (businesses: Array<Business>) => ({
  type: types.SET_BUSINESSES,
  payload: businesses,
});

const setSubCategories = (categories: Array<SubCategory>) => ({
  type: types.SET_SUB_CATEGORIES,
  payload: categories,
});

const businessSuccess = (dispatch: Function) => ({ businesses }: BusinessProps) => {
  dispatch(setBusinesses(businesses));
};

const subCategoriesSuccess = (dispatch: Function) => ({
  subCategories,
}: SubCategoryProps) => {
  dispatch(setSubCategories(subCategories));
};

export const getBusinesses = (query: string) => async (dispatch: Function) => {
  dispatch(setLoading(true));
  const onSuccess = businessSuccess(dispatch);
  await handleResponse("get", "/businesses", onSuccess, dispatch, { query, limit: 3 });
  dispatch(setLoading(false));
};

export const getSubCategories = () => async (dispatch: Function) => {
  dispatch(setLoading(true));
  const onSuccess = subCategoriesSuccess(dispatch);
  await handleResponse("get", "/sub_categories", onSuccess, dispatch, {});
  dispatch(setLoading(false));
};
